import axios from "../helpers/axios";
import { chatConstants } from "./constants";

const getChatsFromResponse = (res) => {
    if (Array.isArray(res?.data?.chats)) return res.data.chats;
    if (Array.isArray(res?.data)) return res.data;
    return [];
};

const getChatFromResponse = (res) => {
    return res?.data?.chat || null;
};

export const fetchAllChatsForAdmin = () => {
    return async (dispatch) => {
        dispatch({ type: chatConstants.FETCH_CHATS_REQUEST });

        try {
            const res = await axios.get("/admin/chats");
            const chats = getChatsFromResponse(res);

            dispatch({
                type: chatConstants.FETCH_CHATS_SUCCESS,
                payload: { chats },
            });

            return chats;
        } catch (error) {
            dispatch({
                type: chatConstants.FETCH_CHATS_FAILURE,
                payload: { error: error?.response?.data?.error || error.message },
            });

            return [];
        }
    };
};

export const fetchChats = (userId) => {
    return async (dispatch) => {
        dispatch({ type: chatConstants.FETCH_CHATS_REQUEST });

        try {
            const res = await axios.get(`/chat/${userId}`);
            const chats = getChatsFromResponse(res);

            dispatch({
                type: chatConstants.FETCH_CHATS_SUCCESS,
                payload: { chats },
            });

            return chats;
        } catch (error) {
            dispatch({
                type: chatConstants.FETCH_CHATS_FAILURE,
                payload: { error: error?.response?.data?.error || error.message },
            });

            return [];
        }
    };
};

export const fetchMyChats = (type = "all") => {
    return async (dispatch) => {
        dispatch({ type: chatConstants.FETCH_MY_CHATS_REQUEST });

        try {
            const res = await axios.get(`/chats/my?context=dm&type=${encodeURIComponent(type)}`);
            const chats = getChatsFromResponse(res);

            dispatch({
                type: chatConstants.FETCH_MY_CHATS_SUCCESS,
                payload: { chats },
            });

            return chats;
        } catch (error) {
            dispatch({
                type: chatConstants.FETCH_MY_CHATS_FAILURE,
                payload: { error: error?.response?.data?.error || error.message },
            });

            return [];
        }
    };
};

export const fetchOfficeChats = (officeId, type = "all") => {
    return async (dispatch) => {
        dispatch({ type: chatConstants.FETCH_MY_CHATS_REQUEST });

        try {
            const res = await axios.get(`/office/${officeId}/chats?type=${encodeURIComponent(type)}`);
            const chats = getChatsFromResponse(res);

            dispatch({
                type: chatConstants.FETCH_MY_CHATS_SUCCESS,
                payload: { chats },
            });

            return chats;
        } catch (error) {
            dispatch({
                type: chatConstants.FETCH_MY_CHATS_FAILURE,
                payload: { error: error?.response?.data?.error || error.message },
            });

            return [];
        }
    };
};

export const createDirectChat = (peerId) => {
    return async (dispatch) => {
        dispatch({ type: chatConstants.CREATE_DM_REQUEST });

        try {
            const res = await axios.post(`/chats/dm/${peerId}`);
            const chat = getChatFromResponse(res);

            dispatch({
                type: chatConstants.CREATE_DM_SUCCESS,
                payload: { chat },
            });

            return { payload: { chat } };
        } catch (error) {
            dispatch({
                type: chatConstants.CREATE_DM_FAILURE,
                payload: { error: error?.response?.data?.error || error.message },
            });

            return null;
        }
    };
};

export const createOfficeDirectChat = ({ officeId, peerId }) => {
    return async (dispatch) => {
        dispatch({ type: chatConstants.CREATE_DM_REQUEST });

        try {
            const res = await axios.post(`/office/${officeId}/chats/dm/${peerId}`);
            const chat = getChatFromResponse(res);

            dispatch({
                type: chatConstants.CREATE_DM_SUCCESS,
                payload: { chat },
            });

            return { payload: { chat } };
        } catch (error) {
            const message = error?.response?.data?.error || error.message || "Не удалось открыть личный чат";

            dispatch({
                type: chatConstants.CREATE_DM_FAILURE,
                payload: { error: message },
            });

            return { error: message };
        }
    };
};

export const getOrCreateSavedChat = () => {
    return async (dispatch) => {
        dispatch({ type: chatConstants.CREATE_DM_REQUEST });

        try {
            const res = await axios.post("/chats/saved");
            const chat = getChatFromResponse(res);

            dispatch({
                type: chatConstants.CREATE_DM_SUCCESS,
                payload: { chat },
            });

            return { payload: { chat } };
        } catch (error) {
            dispatch({
                type: chatConstants.CREATE_DM_FAILURE,
                payload: { error: error?.response?.data?.error || error.message },
            });

            return null;
        }
    };
};

export const getOrCreateOfficeSavedChat = (officeId) => {
    return async (dispatch) => {
        dispatch({ type: chatConstants.CREATE_DM_REQUEST });

        try {
            const res = await axios.post(`/office/${officeId}/chats/saved`);
            const chat = getChatFromResponse(res);

            dispatch({
                type: chatConstants.CREATE_DM_SUCCESS,
                payload: { chat },
            });

            return { payload: { chat } };
        } catch (error) {
            dispatch({
                type: chatConstants.CREATE_DM_FAILURE,
                payload: { error: error?.response?.data?.error || error.message },
            });

            return null;
        }
    };
};

export const createRoomChat = ({ title, participants = [] }) => {
    return async (dispatch) => {
        dispatch({ type: chatConstants.CREATE_ROOM_REQUEST });

        try {
            const res = await axios.post("/chats/room", { title, participants });
            const chat = getChatFromResponse(res);

            dispatch({
                type: chatConstants.CREATE_ROOM_SUCCESS,
                payload: { chat },
            });

            return { payload: { chat } };
        } catch (error) {
            dispatch({
                type: chatConstants.CREATE_ROOM_FAILURE,
                payload: { error: error?.response?.data?.error || error.message },
            });

            return null;
        }
    };
};

export const createOfficeRoomChat = ({ officeId, title, participants = [] }) => {
    return async (dispatch) => {
        dispatch({ type: chatConstants.CREATE_ROOM_REQUEST });

        try {
            const res = await axios.post(`/office/${officeId}/chats/room`, { title, participants });
            const chat = getChatFromResponse(res);

            dispatch({
                type: chatConstants.CREATE_ROOM_SUCCESS,
                payload: { chat },
            });

            return { payload: { chat } };
        } catch (error) {
            const message = error?.response?.data?.error || error.message || "Не удалось создать групповой чат";

            dispatch({
                type: chatConstants.CREATE_ROOM_FAILURE,
                payload: { error: message },
            });

            return { error: message };
        }
    };
};

export const openOfficeProductChat = ({ officeId, productId, purpose = "general" }) => {
    return async (dispatch) => {
        dispatch({ type: chatConstants.CREATE_ROOM_REQUEST });

        try {
            const res = await axios.post(`/office/${officeId}/chats/product/${productId}`, { purpose });
            const chat = getChatFromResponse(res);

            dispatch({
                type: chatConstants.CREATE_ROOM_SUCCESS,
                payload: { chat },
            });

            return { payload: { chat } };
        } catch (error) {
            dispatch({
                type: chatConstants.CREATE_ROOM_FAILURE,
                payload: { error: error?.response?.data?.error || error.message },
            });

            return null;
        }
    };
};

export const openOfficeOrderChat = ({ officeId, orderId, purpose = "general" }) => {
    return async (dispatch) => {
        dispatch({ type: chatConstants.CREATE_ROOM_REQUEST });

        try {
            const res = await axios.post(`/office/${officeId}/chats/order/${orderId}`, { purpose });
            const chat = getChatFromResponse(res);

            dispatch({
                type: chatConstants.CREATE_ROOM_SUCCESS,
                payload: { chat },
            });

            return { payload: { chat } };
        } catch (error) {
            dispatch({
                type: chatConstants.CREATE_ROOM_FAILURE,
                payload: { error: error?.response?.data?.error || error.message },
            });

            return null;
        }
    };
};

export const addParticipantToRoom = (chatId, userId) => {
    return async (dispatch) => {
        const res = await axios.post(`/chats/${chatId}/participants`, { userId });
        const chat = res?.data?.chat || null;

        if (chat?._id) {
            dispatch({
                type: chatConstants.UPSERT_CHAT,
                payload: { chat },
            });
        }

        return res?.data || null;
    };
};

export const removeParticipantFromRoom = (chatId, userId) => {
    return async (dispatch) => {
        const res = await axios.delete(`/chats/${chatId}/participants/${userId}`);
        const chat = res?.data?.chat || null;

        if (chat?._id) {
            dispatch({
                type: chatConstants.UPSERT_CHAT,
                payload: { chat },
            });
        }

        return res?.data || null;
    };
};

export const fetchStarred = (chatId, { before, limit = 50 } = {}) => {
    return async () => {
        const qs = new URLSearchParams();

        if (before) qs.set("before", before);
        qs.set("limit", String(limit));

        const res = await axios.get(`/chat/${chatId}/starred?${qs.toString()}`);

        return res?.data || { items: [], nextCursor: null };
    };
};

export const fetchChatMedia = (chatId, { type = "image", before, limit = 60 } = {}) => {
    return async () => {
        const qs = new URLSearchParams();

        qs.set("type", type);
        qs.set("limit", String(limit));

        if (before) qs.set("before", before);

        const res = await axios.get(`/chat/${chatId}/media?${qs.toString()}`);

        return res?.data || { items: [], nextCursor: null };
    };
};

export const searchChat = (chatId, { q = "", dateFrom, dateTo, starred = false, before, limit = 50 } = {}) => {
    return async () => {
        const params = new URLSearchParams();

        if (q) params.set("q", q);
        if (dateFrom) params.set("dateFrom", dateFrom);
        if (dateTo) params.set("dateTo", dateTo);
        if (starred) params.set("starred", "true");
        if (before) params.set("before", before);

        params.set("limit", String(limit));

        const res = await axios.get(`/chat/${chatId}/timeline?${params.toString()}`);

        return res?.data || { items: [], nextCursor: null };
    };
};

export const setActiveChatIdLocal = (chatId) => ({
    type: chatConstants.SET_ACTIVE_CHAT_ID,
    payload: { chatId },
});

export const createEntityOfficeChat = ({
    officeId,
    entityType,
    entityId,
    title,
    subtitle = "",
    purpose = "general",
    participants = [],
    snapshot = null,
}) => {
    return async (dispatch) => {
        dispatch({ type: chatConstants.CREATE_ROOM_REQUEST });

        try {
            const res = await axios.post(`/office/${officeId}/chats/entity`, {
                entityType,
                entityId,
                title,
                subtitle,
                purpose,
                participants,
                snapshot,
            });

            const chat = getChatFromResponse(res);

            dispatch({
                type: chatConstants.CREATE_ROOM_SUCCESS,
                payload: { chat },
            });

            return {
                payload: { chat },
                meta: res?.data?.meta || {},
                reused: !!res?.data?.reused,
            };
        } catch (error) {
            const message = error?.response?.data?.error || error.message;

            dispatch({
                type: chatConstants.CREATE_ROOM_FAILURE,
                payload: { error: message },
            });

            return { error: message };
        }
    };
};

export const fetchEntityOfficeChats = ({
    officeId,
    entityType,
    entityId,
}) => {
    return async (dispatch) => {
        dispatch({ type: chatConstants.FETCH_CHATS_REQUEST });

        try {
            const qs = new URLSearchParams();

            qs.set("entityType", entityType);
            qs.set("entityId", entityId);

            const res = await axios.get(`/office/${officeId}/chats/entity?${qs.toString()}`);
            const chats = getChatsFromResponse(res);
            const meta = res?.data?.meta || {};

            dispatch({
                type: chatConstants.FETCH_CHATS_SUCCESS,
                payload: {
                    chats,
                    replace: false,
                },
            });

            return {
                chats,
                meta,
            };
        } catch (error) {
            const message = error?.response?.data?.error || error.message;

            dispatch({
                type: chatConstants.FETCH_CHATS_FAILURE,
                payload: { error: message },
            });

            return {
                chats: [],
                meta: {},
                error: message,
            };
        }
    };
};
